var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFilters = function SvgFilters(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    fillRule: "evenodd",
    d: "M10.834 9.167a3.335 3.335 0 0 1-3.229-2.5H1.667V5h5.938a3.335 3.335 0 0 1 6.562.833 3.333 3.333 0 0 1-3.333 3.334m5-4.167h2.5v1.667h-2.5zM6.667 17.5A3.335 3.335 0 0 1 3.439 15H1.667v-1.667h1.772a3.335 3.335 0 0 1 6.561.834A3.333 3.333 0 0 1 6.667 17.5m5-2.5h6.667v-1.667h-6.667zm-3.333-.833a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0M12.5 5.833a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0",
    clipRule: "evenodd"
  })));
};
export default SvgFilters;